
























import { Component, Vue } from 'vue-property-decorator';
import User from '@/apiClient/User';

@Component({
    name: 'AvatarEdit'
})
export default class AvatarEdit extends Vue {
    user: User;

    created(){
        this.user = new User();
    }
    data(){
        return {
            user: User,
            form: {
                image: null
            }
        }
    }
    submit(){

    }
}
